/**
 * Ícone SVG para marcadores de Reserva no mapa FTTH.
 * Pin com bobina (três anéis sobrepostos).
 */

import {
  buildMapPinSvg,
  MAP_PIN_ANCHOR_X,
  MAP_PIN_ANCHOR_Y,
  MAP_PIN_DISPLAY_HEIGHT,
  MAP_PIN_DISPLAY_WIDTH,
} from './mapPinIcons';

const DEFAULT_RESERVA_COLOR = '#0091da';

function normalizeColor(color?: string | null): string {
  if (color && /^#[0-9A-Fa-f]{3,8}$/.test(color)) return color;
  return DEFAULT_RESERVA_COLOR;
}

export const RESERVA_ICON_WIDTH = MAP_PIN_DISPLAY_WIDTH;
export const RESERVA_ICON_HEIGHT = MAP_PIN_DISPLAY_HEIGHT;
export const RESERVA_ICON_ANCHOR_X = MAP_PIN_ANCHOR_X;
export const RESERVA_ICON_ANCHOR_Y = MAP_PIN_ANCHOR_Y;

export function getReservaIconDataUrl(color: string = DEFAULT_RESERVA_COLOR): string {
  const c = normalizeColor(color);
  return 'data:image/svg+xml,' + encodeURIComponent(buildMapPinSvg(c, { showCoilRings: true }));
}
